<template>
  <IQOSModal @backdropClick="$emit('close')">
    <template #title>
        iiko
    </template>

    <div class="v1-grey-3-color">
      <p class="iqos-comment mt-16">
        {{ $t("integrations.iiko_connect_modal.download") }}
        <a class="c-green" href="/packages/QRWaiterIikoPlugin.zip">
          QRWaiterIikoPlugin v.1.2.0
        </a>
      </p>
      <p
        class="iqos-comment mt-16"
        v-html="$t('integrations.iiko_connect_modal.extract')"
      ></p>
      <p
        class="iqos-comment mt-16"
        v-html="$t('integrations.iiko_connect_modal.license')"
      ></p>
      <p class="iqos-comment mt-16">
        {{ $t("integrations.iiko_connect_modal.restart") }}
      </p>
      <p class="iqos-comment mt-16">
        {{ $t("integrations.iiko_connect_modal.connect") }}
      </p>
      <h3>
        {{ auth_code }}
      </h3>
      <p class="iqos-comment mt-16">
        {{ $t("integrations.iiko_connect_modal.autoclose") }}
      </p>
    </div>
  </IQOSModal>
</template>

<script>
import IikoAPI from "@/api/iiko";

export default {
  data() {
    return {
      auth_code: "-----",
    };
  },
  methods: {
    fetchCode() {
      IikoAPI.connect(this.cafe._id)
        .then((data) => {
          this.auth_code = data.code;
        })
        .catch((error) => {
          alert(error);
        });
    },
    checkStatus() {
      IikoAPI.checkStatus(this.cafe._id)
        .then((data) => {
          if (data.is_connected) {
            this.$store.dispatch("fetchCafe");
            this.$emit("close");
          } else {
            setTimeout(this.checkStatus, 5000);
          }
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    this.fetchCode();

    setTimeout(this.checkStatus, 5000);
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
};
</script>

<style>
</style>